export enum HistoryEntryType {
  email = 'email',
  sms = 'sms',
  push = 'push',
  login = 'login',
}

export enum HistoryEntryName {
  email_account_activated_leedflow = 'email_account_activated_leedflow',
  email_welcome_leedflow = 'email_welcome_leedflow',
  email_member_welcome_leedflow = 'email_member_welcome_leedflow',
  login_as_user_leedflow = 'login_as_user_leedflow',
  login_as_user_leedpulse = 'login_as_user_leedpulse',
}

export const historyEntryNameAsString = (name: HistoryEntryName, ): string => {
  switch (name) {
    case HistoryEntryName.email_welcome_leedflow:
      return 'Leedflow : bienvenue (abonnement créé)';
    case HistoryEntryName.email_account_activated_leedflow:
      return 'Leedflow : identifiants du 1er utilisateur';
    case HistoryEntryName.email_member_welcome_leedflow:
      return 'Leedflow : identifiants d\'un utilisateur ajouté';
    case HistoryEntryName.login_as_user_leedflow:
      return 'Connexion "en tant que" sur Leedflow';
    case HistoryEntryName.login_as_user_leedpulse:
      return 'Connexion "en tant que" sur Leedpulse';
    default:
      return name;
  }
};

export const historyEntryTypeAsString = (type: HistoryEntryType): string => {
  switch (type) {
    case HistoryEntryType.email:
      return '📧 Email';
    case HistoryEntryType.sms:
      return '💬 SMS';
    case HistoryEntryType.push:
      return '📳 Push';
    case HistoryEntryType.login:
      return '🔑 Connexion';
    default:
      return '❓ Inconnu';
  }
};
